const DateDialect = {
	NULL: "", // Used on the User when it should refer to the Company setting.
	DMY: "day-month-year",
	MDY: "month-day-year"
};
export default DateDialect;
